<template>
  <!---->
  <div style="display: flex; flex-direction: row;justify-content: flex-start;">
    <slot name="prepend" style="background: #f5f5f5;"></slot>
    <input :id="'c' + $props.controlId"
      v-if="$props.type!=='textarea'"
      :type="type[$props.controlType] || $props.type || 'input'"
      :name="'c' + $props.controlId"
      :value="modelValue"
      :disabled="$props.disabled"
      :readonly="$props.readonly"
      :class="$props.class"
      :placeholder="$props.placeholder"
      :title="$props.title"
      :size="$props.size"
      :max="$props.max"
      :min="$props.min"
      :maxlength="Number($props.maxlength)"
      :autocomplete="$props.autocomplete"
      :list="$props.optionKey"
      @input="myInput"
      @blur="blurInput"
      :key="'ckey_'+$props.controlId"/>
    <textarea :id="'c' + $props.controlId"
              v-if="$props.type==='textarea'"
              :rows="3"
              :name="'c' + $props.controlId"
              :value="modelValue"
              :disabled="$props.disabled"
              :readonly="$props.readonly"
              :class="$props.class"
              :placeholder="$props.placeholder"
              :title="$props.title"
              :size="$props.size"
              :maxlength="Number($props.maxlength)"
              :autocomplete="$props.autocomplete"
              :list="$props.optionKey"
              @input="myInput"
              :key="'ckey_'+$props.controlId">
    </textarea>
      <!--文本框的备选项-->
      <datalist v-if="typeof($props.optionKey)!=='undefined'" :id="$props.optionKey">
        <option :key="item.value" v-for="item in $props.optionList" :label="item.title" :value="item.value" />
      </datalist>
  </div>
</template>

<script lang="ts">
import { reactive } from 'vue'
import { truncateInputEmoji } from '/@/utils/common/compUtils';

const type = {
  100: 'textarea', // 多行文本框
  101: 'text', // 单行文本框
  102: 'password', // 密码
  103: 'tel', // 电话
  104: 'email', // 电子邮件
  105: 'url', // url
  106: 'search', // 搜索
  107: 'color', // 颜色
  108: 'text', // 弹窗选择记录
  110: 'date', // 日期
  111: 'datetime-local', // 日期时间
  112: 'time', // 时间
  113: 'week', // 年月
  114: 'month', // 年周
  120: 'number', // 数字
  121: 'range', // 滑块
  130: 'file', // 上传文件
  131: 'file', // 上传图片
  140: 'fulltext', // 富文本编辑器
  150: 'checkbox', // 勾选
  152: 'checkboxs', // 多选组
  153: 'radios', // 单选组
  170: 'select', // 下拉列表框 单选
  171: 'selects', // 列表框 多选
  172: 'selectMore', // 联动下拉列表框
  173: 'treeSelect' // 树选择框
}

export default {
  name: 'v-input',
  props: {
    modelValue: String,
    controlId: Number, // 编号，区别同一个表单里的其他控件
    colName: String, // 字段名称
    controlType: Number, // 用类型编号表示type
    type: String,
    clearable: {
      // isClear  连续添加时是否恢复默认值
      type: Boolean,
      default: false
    },
    defaultValue: String, // 默认值
    autofocus: { // 是否自动获得焦点
      type: Boolean,
      default: false
    },
    disabled: {
      // 是否禁用
      type: Boolean,
      default: false
    },
    required: { // 必填
      type: Boolean,
      default: true
    },
    readonly: { // 只读
      type: Boolean,
      default: false
    },
    pattern: String, // 用正则做验证。
    class: {
      type: String,
      default: 'ant-input ant-input-md'
    },
    placeholder: String,
    title: String, // 提示信息
    size: Number, // 字符宽度
    maxlength: [Number, String], // 最大字符数
    autocomplete: { // off
      type: String,
      default: 'off'
    },
    optionKey: String, // 备选文字标识
    optionItem: Object, // 备选的选项
    max: Number, // 最大值
    min: Number, // 最小值
  },
  emits: ['input', 'update:modelValue', 'change', 'blur'],
  setup (props, context) {
    // console.log(props)
    // 提交数据
    const myInput = (e) => {
      console.log(e)
      console.log(context)
      truncateInputEmoji(e)
      if (props.max != null && props.type === 'number') {
        if (e.target.value && (Number(e.target.value) > Number(props.max))) {
          e.target.value = props.max;
          context.emit('update:modelValue', props.max)
          context.emit('change', props.max)
          return;
        }
      }
      if (props.min != null && props.type === 'number') {
        if (e.target.value && (Number(e.target.value) < Number(props.min))) {
          e.target.value = props.min;
          context.emit('update:modelValue', props.min)
          context.emit('change', props.min)
          return;
        }
      }
      context.emit('update:modelValue', e.target.value)
      context.emit('change', e.target.value)
    }

    const blurInput = (e) => {
      context.emit('blur', e);
    }

    return {
      type,
      myInput,
      blurInput,
    }
  }
}
</script>

<style scoped>
  input {
    border-radius: 5px;
  }

  .ant-input {
    font-feature-settings: "tnum";
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    color: rgba(0,0,0,.85);
    display: inline-block;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    margin: 0;
    padding: 4px 11px;
    position: relative;
    transition: all .3s;
    width: 100%;
    border-radius: 5px;
  }

  .ant-input:focus, .ant-input:hover {
    border-color: #40a9ff;
    border-right-width: 1px!important;
  }
</style>
